module.exports = __webpack_public_path__ + "static/media/art-sample-4.55b33238.png";